import { withRouter } from 'react-router-dom';

const SelectImpactDataFieldsModal = (props) => {
    return <></>;
};

export default withRouter(SelectImpactDataFieldsModal);
